function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Generated file, do not edit directly.
 */
import React from 'react';
import { Icon } from '@dna/icon';
export function IconArrowDropDown(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    width: "24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10l5 5 5-5z",
    fill: "currentColor"
  })));
}